const t = {
  name: "ClipboardValidate",
  dimensions: { width: 28, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 28 40" style="enable-background:new 0 0 28 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M12,30.4l9.4-9.4L20,19.6l-8,8l-4-4L6.6,25L12,30.4z"/>
		<path class="st0" d="M9,5v1H3C1.3,6,0,7.3,0,9v28c0,1.7,1.3,3,3,3h22c1.7,0,3-1.3,3-3V9c0-1.7-1.3-3-3-3h-6V5c0-2.8-2.2-5-5-5
			S9,2.2,9,5z M14,2c1.7,0,3,1.3,3,3v1h-6V5C11,3.3,12.3,2,14,2z M8,8h12v2H8V8z M2,9c0-0.6,0.4-1,1-1h3v4h16V8h3c0.6,0,1,0.4,1,1
			v28c0,0.6-0.4,1-1,1H3c-0.6,0-1-0.4-1-1V9z"/>
	</g>
</g>
</svg>
  `
};
export {
  t as ClipboardValidate
};
